<template>
  <span
    class="mx-3 h-[--navbar-height] border-l border-neutral-200 dark:border-neutral-500/30 lg:mx-5"
  />
</template>
